import { loadable } from '@direct-frontend/modules-render';
import { DelayedSuspense } from '#shared/components/DelayedSuspense';
import { PageStub } from '#shared/components/PageStub';

const SettingsSeoLazy = loadable(() => import(/* webpackChunkName: "SettingsSeo" */ './SettingsSeoSuspense'));

export const SettingsSeoAsync = () => (
    <DelayedSuspense fallback={<PageStub />}>
        <SettingsSeoLazy />
    </DelayedSuspense>
);
